import React, {PropTypes} from 'react';
import TextInput from '../common/TextInput';
import TextAreaInput from '../common/TextAreaInput';
import SelectInput from '../common/SelectInput';
import Button from '../common/Button';
import '../../styles/establishment/establishmentForm.css';
import '../../styles/bulkTransfer/bulkTransferForm.css';

const BulkTransferQueryForm = ({ form, onSubmit, onChange, onCancel, onBlur, errors, data, formIsValid, user }) => {
  let questions = [];
  let topRowQuestions = [];
  let middleRowQuestions = [];
  let bottomRowQuestions = [];
  if (form.formQuestions) {
    form.formQuestions.forEach(question => {
      let questionParts = [];
      question.questionParts.map(questionPart => {
        let type = questionPart.questionPartType;
        if (question.questionName === 'Transfer From Email' || question.questionName === 'Transfer To Email') {
          topRowQuestions.push(<TextInput
                                type='text'
                                onChange={onChange}
                                placeholder={questionPart.questionPartLabel}
                                value={data[questionPart.questionPartName]}
                                label={questionPart.questionPartLabel}
                                name={questionPart.questionPartName}
                                className={'establishment-text-input'}
                                fieldClass={questionPart.questionPartName}
                                error={errors[questionPart.questionPartName]}
                                tooltip={questionPart.questionPartTooltipHelp}
                                required={questionPart.questionPartRequired == '1'}
                                onBlur={onBlur}
                                disabled={question.questionName == 'Transfer To Email' ? true : false}
                                />)
          if (topRowQuestions.length === 2) {
            questions.push(
              <div>
                {topRowQuestions}
              </div>
            )
          }
        }
        else if (question.questionName === 'streetAddress' || question.questionName === 'city') {
          middleRowQuestions.push(<TextInput
            type='text'
            onChange={onChange}
            placeholder={questionPart.questionPartLabel}
            value={data[questionPart.questionPartName]}
            label={questionPart.questionPartLabel}
            name={questionPart.questionPartName}
            className={'establishment-text-input'}
            fieldClass={questionPart.questionPartName}
            error={errors[questionPart.questionPartName]}
            tooltip={questionPart.questionPartTooltipHelp}
            required={false}
            onBlur={onBlur}/>)
          if (middleRowQuestions.length === 3) {
            questions.push(<div>{middleRowQuestions}</div>)
          }
        }
        else if (question.questionName === 'state') {
          middleRowQuestions.push(<SelectInput 
                                  name={questionPart.questionPartName}
                                  label={questionPart.questionPartLabel}
                                  onChange={onChange}
                                  value={data[questionPart.questionPartName]}
                                  error={errors[questionPart.questionPartName]}
                                  options={questionPart.questionPartOptions}
                                  className={'establishment-select-input'}
                                  fieldClass={questionPart.questionPartName}
                                  required={false}
                                  defaultOption='--Select--'
                                  onBlur={onBlur}/>)
          if (middleRowQuestions.length === 3) {
            questions.push(<div>{middleRowQuestions}</div>)
          }
        }
        else if (question.questionName === 'establishmentName' || question.questionName === 'ein') {
          bottomRowQuestions.push(<TextInput
            type='text'
            onChange={onChange}
            placeholder={questionPart.questionPartLabel}
            value={data[questionPart.questionPartName]}
            label={questionPart.questionPartLabel}
            name={questionPart.questionPartName}
            className={'establishment-text-input'}
            fieldClass={questionPart.questionPartName}
            error={errors[questionPart.questionPartName]}
            tooltip={questionPart.questionPartTooltipHelp}
            required={false}
            onBlur={onBlur}/>)
          if (bottomRowQuestions.length === 2) {
            questions.push(<div>{bottomRowQuestions}</div>)
          }
        }
      })
    })
  }
  
  return (
    <form id='transferForm'>
      <div className='transferFormRow'>
        {topRowQuestions}
      </div>
      <div className='transferFormSectionTitle'>User Verification</div>
      <h5 className='transferFormH5'>Please provide at least 2 of the following criteria: Address, City, State, EIN #, and/or Establishment Name. This query is used to confirm your association with the owner of the records and will not limit the number of establishments returned upon successful verification.</h5>
      <div className='validationFelds'>
        <div className='transferFormRow'>{middleRowQuestions}</div>
        <div className='transferFormRow'>{bottomRowQuestions}</div>
      </div>
      <Button value={'Verify'} onClick={onSubmit} disabled={!formIsValid} className='queryFormButton'/>
    </form>
  )
};

BulkTransferQueryForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  data: PropTypes.object,
  formIsValid: PropTypes.bool,
  user: PropTypes.object
};

export default BulkTransferQueryForm;



/** WEBPACK FOOTER **
 ** ./src/components/bulkTransfer/BulkTransferQueryForm.js
 **/